import React from 'react';
import { Box } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

type FinancialChartProps = {
  monthlyPaid: number[];
  monthlyPaidLastYear: number[];
  currentYearLabel: string;
  lastYearLabel: string;
  // Prefijo del tooltip. '$' para montos (default); vacío para conteos (alumnos, programas).
  valuePrefix?: string;
};

const MONTH_LABELS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const FinancialChart: React.FC<FinancialChartProps> = ({
  monthlyPaid,
  monthlyPaidLastYear,
  currentYearLabel,
  lastYearLabel,
  valuePrefix = '$',
}) => {
  const seriesCurrent = (monthlyPaid && monthlyPaid.length ? monthlyPaid : new Array(12).fill(0));
  const seriesLast = (monthlyPaidLastYear && monthlyPaidLastYear.length
    ? monthlyPaidLastYear
    : new Array(12).fill(0));

  const lastYearBaseColor = '#F2AC32';
  const currentYearBaseColor = '#2C82B3';

  const lastYearGradient: Highcharts.GradientColorObject = {
    linearGradient: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1,
    },
    stops: [
      [0, Highcharts.color(lastYearBaseColor).setOpacity(0.4).get('rgba') as string],
      [1, Highcharts.color(lastYearBaseColor).setOpacity(0).get('rgba') as string],
    ],
  };

  const currentYearGradient: Highcharts.GradientColorObject = {
    linearGradient: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1,
    },
    stops: [
      [0, Highcharts.color(currentYearBaseColor).setOpacity(0.4).get('rgba') as string],
      [1, Highcharts.color(currentYearBaseColor).setOpacity(0).get('rgba') as string],
    ],
  };

  const options: Highcharts.Options = {
    chart: {
      type: 'area',
      height: 260,
      spacing: [10, 10, 15, 10],
    },
    title: {
      text: undefined,
    },
    credits: {
      enabled: false,
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      symbolRadius: 10,
    },
    xAxis: {
      categories: MONTH_LABELS,
      tickLength: 0,
      lineColor: '#E2E2E2',
    },
    yAxis: {
      title: {
        text: undefined,
      },
      min: 0,
      gridLineColor: '#F0F0F0',
      labels: {
        formatter() {
          const value = Number(this.value || 0);
          if (value >= 1_000_000) return `${value / 1_000_000}M`;
          if (value >= 1_000) return `${value / 1_000}K`;
          return `${value}`;
        },
      },
    },
    tooltip: {
      shared: true,
      valueDecimals: 0,
      valuePrefix,
    },
    plotOptions: {
      series: {
        lineWidth: 1,
        marker: {
          enabled: true,
          radius: 4,
        },
      },
      area: {
        fillOpacity: 0.15,
      },
    },
    series: [
      {
        type: 'area',
        name: lastYearLabel,
        data: seriesLast,
        color: lastYearBaseColor,
        fillColor: lastYearGradient,
      },
      {
        type: 'area',
        name: currentYearLabel,
        data: seriesCurrent,
        color: currentYearBaseColor,
        fillColor: currentYearGradient,
      },
    ],
  };

  return (
    <Box>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};
export default FinancialChart;
